<template>
  <div v-if="display">
    <modal-layout-top :title="title"/>
    <div class="content slider-modal">

      <div class="tabs">
        <ul>
          <li :class="{ 'is-active': tab === 'overview'}"><a @click="tab='overview'">Översikt</a></li>
          <li :class="{ 'is-active': tab === 'contact'}"><a @click="tab='contact'">Kontaktuppgifter</a></li>
        </ul>
      </div>

      <div v-if="tab === 'overview'" class="slider-modal-fields">
        <div class="field">
          <label class="label">Namn</label>
          <input class="input" type="text" v-model="reseller.name" />
        </div>

        <div class="field">
          <label class="label">Org. nr.</label>
          <input class="input" type="email" v-model="reseller.organizationNumber" />
        </div>

        <div class="slider-subtitle">Kommentar</div>
        <div class="field-full">
          <textarea class="textarea" v-model="reseller.comments" />
        </div>

        <template v-if="resellerId">
          <div class="slider-subtitle">Övrigt</div>
          <div class="field-full meta-data">Skapad av {{ reseller.createdByFullName }} {{ reseller.dateCreated | dateTime }}</div>
          <div class="field-full meta-data" v-if="reseller.modifiedByUserId">Senast ändrad av {{ reseller.modifiedByFullName }} {{ reseller.dateModified | dateTime }}</div>
        </template>
      </div>

      <div v-if="tab === 'contact'" class="slider-modal-fields">
        <div class="slider-subtitle">Adress</div>

        <div class="field">
          <label class="label">Gatuadress</label>
          <input class="input" type="text" v-model="reseller.streetAddress">
        </div>

        <div class="field">
          <label class="label">Postnummer</label>
          <input class="input" type="text" v-model="reseller.zip">
        </div>

        <div class="field">
          <label class="label">Postort</label>
          <input class="input" type="text" v-model="reseller.city">
        </div>

        <div class="field">
          <label class="label">Land</label>
          <div class="select">
            <select v-model="reseller.countryId">
              <option :value="null">Välj land...</option>
              <option v-for="country in countries" :key="country.iso2" :value="country.countryId">{{ country.nameSwedish }}</option>
            </select>
          </div>
        </div>
        <div class="field-full">
          <hr>
        </div>

        <div class="field">
          <label class="label">Email</label>
          <div class="is-flex">
            <input class="input is-inline-input" type="text" v-model="reseller.email">
            <a class="button is-inline-button is-info" :href="emailHref" :disabled="!emailHref"><i class="fal fa-envelope"></i></a>
          </div>
        </div>

        <div class="field">
          <label class="label">Telefon</label>
          <div class="is-flex">
            <input class="input is-inline-input" type="text" v-model="reseller.phone">
            <a class="button is-inline-button is-info" :href="phoneHref" :disabled="!reseller.phone"><i class="fal fa-phone"></i></a>
          </div>
        </div>
      </div>

      <modal-layout-buttons :store-name="'resellers'" />

    </div>
  </div>

</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  name: 'reseller-modal',

  data () {
    return {
      reseller: {
        name: ''
      },
      tab: 'overview',
      submitted: false,
      display: false
    }
  },
  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },
  props: {
    resellerId: {
      type: Number,
      required: false
    }
  },
  computed: {
    ...mapState({
      resellers: state => state.resellers.all,
      countries: state => state.meta.all.countries
    }),

    emailHref () {
      if (this.reseller.email) {
        return `mailto:${this.reseller.email}`
      }

      return null
    },

    phoneHref () {
      if (this.reseller.phone) {
        return `tel:${this.reseller.phone}`
      }

      return null
    },

    title: function () {
      if (!this.resellerId) {
        return 'Lägg till ny återförsäljare'
      } else {
        return 'Redigera återförsäljare ' + this.reseller.name
      }
    }
  },

  methods: {
    ...mapActions('resellers', ['update', 'create', 'getById']),

    closePanel () {
      this.$emit('closePanel', { response: this.reseller })
    },

    getFormattedAddress (address) {
      let parts = []

      if (address.streetAddress) {
        parts.push(address.streetAddress)
      }
      if (address.zip || address.city) {
        parts.push(address.zip + ' ' + address.city)
      }
      return parts.join(', ')
    },

    save () {
      this.submitted = true
      this.$validator.validateAll()

      if (this.resellerId) {
        this.update(this.reseller).then(response => {
          this.closePanel()
        })
      } else {
        this.create(this.reseller).then(reseller => {
          this.reseller = reseller
          this.closePanel()
        })
      }
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    let promises = []

    if (this.resellerId) {
      promises.push(this.getById(this.resellerId).then(reseller => {
        this.reseller = reseller.result
      }))
    }

    Promise.all(promises).then(() => {
      this.display = true
    })
  }
}
</script>

<style lang="scss" scoped>
  .is-inline-input {
    flex-grow: 1;
  }
  .is-inline-button {
    text-align: right;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/ResellerModal.vue